import { BaseQueryParams } from "../baseQuery";

export const estimatorService = BaseQueryParams(
  "estimatorService",
).injectEndpoints({
  endpoints: (builder) => ({
    getEstimatorPreview: builder.mutation({
      query: (body) => ({
        url: `/estimation/preview`,
        method: "POST",
        body,
      }),
    }),

    estimation: builder.mutation({
      query: (body) => ({
        url: `/estimation/calculation`,
        method: "POST",
        body,
      }),
    }),

    estimatorRegister: builder.mutation({
      query: (data) => ({
        url: "/auth/simple-register",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetEstimatorPreviewMutation,
  useEstimationMutation,
  useEstimatorRegisterMutation,
} = estimatorService;
